import styled from 'styled-components';

export const DocumentsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
  }
`;

export const DocumentWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 100%;
  min-width: 150px;
  padding: 3px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.08);

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 186px;
    min-width: 150px;
  }
`;

export const ExtraDocumentsWrapper = styled.div`
  display: flex;
  min-height: 32px;
  padding: 5px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.08);
`;
